import React, { useState, useEffect } from "react";
import LecturerNav from "../../navigation/LecturerNav";
import { useDispatch, useSelector } from 'react-redux';
import { createUsers, getUsers, updateUsers } from '../../actions/login';
import { Grid, CircularProgress, Button } from '@material-ui/core'
import EditIcon from '@material-ui/icons/Edit';

/**
 * This page presents the lecturer with a form to fill out to allow them to input what times they are available along with how many students 
 * they can supervise.
 * When the information us submitted it will automatically show up on the screen which lets them know it submitted properly and sent to the 
 * users colelction in the database.
 * If they already have submitted information they are allowed to edit the information.
 * @returns the edit information form along with the number of students they plan on supervising and the times they are available.
 */

function LecturerEditInfo() {

    const [noStudents, setNoStudents] = useState({
        noOfStudents: ""
    });

    const [times, setTimes] = useState({
        progressTime: "", demoTime: ""
    });

    const [id, setID] = useState(null)

    let number = []
    const userNumber = []

    let time = []
    const userTime = []

    const dispatch = useDispatch();
    useEffect(() => {
        setID(localStorage.getItem("id"))
        dispatch(getUsers());
    }, [dispatch, noStudents, times]);

    const submitStudentNo = (e) => {
        e.preventDefault();

        if(id) {
            dispatch(updateUsers(id, noStudents));
            alert("Number of students updated")
        } else {
            const assigning = Object.assign({}, noStudents)
            assigning.userID = localStorage.getItem("id")
            dispatch(createUsers(assigning));
            alert("Number of students submitted")
        }

        clearFields();
    }

    const submitTimes = (e) => {
        e.preventDefault();

        if(id) {
            console.log(times)
            dispatch(updateUsers(id, times));
            alert("Times updated")
        } else {
            const assigning = Object.assign({}, times)
            assigning.userID = localStorage.getItem("id")
            dispatch(createUsers(assigning));
            alert("Times submitted")
        }
        clearFields();
    }

    const handleEdit = (no) => {
        const newNo = Object.assign({}, noStudents)

        newNo.noOfStudents = no.noOfStudents;

        setID(no._id)
        setNoStudents(newNo);
    }

    const handleTimes = (time) => {
        const newTime = Object.assign({}, times)

        newTime.progressTime = time.progressTime;
        newTime.demoTime = time.demoTime;

        setID(time._id)
        setTimes(newTime);
    }

    const clearFields = () => {
        setID(null);
        setNoStudents({noOfStudents: ''});
    }

    const response = useSelector((state) => state.projects.data);
    if (response){
        number = Array.from(response);
        number.forEach(no => {
            if(no._id === localStorage.getItem("id")) {
                userNumber.push(no);
                console.log("response",userNumber)
            }
        })

        time = Array.from(response)
        time.forEach(t => {
            if(t._id === localStorage.getItem("id")) {
                userTime.push(t);
                console.log("response",userTime)
            }
        })
    }

    return (
        <div>
            <LecturerNav/>
            <form id={id} onSubmit={submitStudentNo}>
                <h1>Edit Information</h1>
                <label>
                    Number of students you are able to take on:
                    <input type="text" name="noofstudents" label="NoOfStudents" value={noStudents ? noStudents.noOfStudents : ''} onChange={(e) => setNoStudents({...noStudents, noOfStudents: e.target.value})}></input>
                </label>
                <input className="submitButton" type="submit" name="submit" onClick={() => updateUsers(id, noStudents)}></input>
            </form>
            <form id={id} onSubmit={submitTimes}>
            <label>
                    Times available for progress presentation:
                    <input type="time" name="progressTime" label="ProgressTime" value={times ? times.progressTime : ''} onChange={(e) => setTimes({...times, progressTime: e.target.value})}></input>
                </label>
                <label>
                    Times available for project demo:
                    <input type="time" name="demoTime" label="DemoTime" value={times ? times.demoTime : ''} onChange={(e) => setTimes({...times, demoTime: e.target.value})}></input>
                </label>
                <input className="submitButton" type="submit" name="submit" onClick={() => updateUsers(id, times)}></input>
            </form>
            {!number.length ? <CircularProgress /> : (
                <Grid >
                    {userNumber.map((no) => (
                        <Grid className="paper" key={no._id} item>
                            <p>Number of students you are planning on supervising: {no.noOfStudents}</p>
                            <Button onClick={() => handleEdit(no)}>
                                <EditIcon/>
                                Edit
                            </Button>
                        </Grid>
                    ))}
                </Grid>
            )}
            {!time.length ? <CircularProgress /> : (
                <Grid >
                    {userTime.map((time) => (
                        <Grid className="paper" key={time._id} item>
                            <p>Progress Presentation Time: {time.progressTime}</p>
                            <p>Project Demonstration Time: {time.demoTime}</p>
                            <Button onClick={() => handleTimes(time)}>
                                <EditIcon/>
                                Edit
                            </Button>
                        </Grid>
                    ))}
                </Grid>
            )}
        </div>
    )
}

export default LecturerEditInfo